<template>
  <div class="grid grid-cols-11 items-center" data-cy="email-alias">
    <span class="col-span-4 break-words text-headline">
      {{ userAlias }}
    </span>
    <div class="col-span-6 flex items-center space-x-2">
      <avatar-with-name :user="alias.user" />
      <span class="text-xs text-label">
        {{ alias.user.email }}
      </span>
    </div>

    <action-menu-wrapper
      class="justify-self-end"
      :items="menuItems"
      :offset
      teleport
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { COMMON_MENU_OFFSET } from "@/helpers/constants";

import ActionMenuWrapper, {
  type MenuItem,
} from "@/components/ui/ActionMenuWrapperV2.vue";
import AvatarWithName from "@/components/ui/AvatarWithName.vue";

import type { IWhitelabel, WhitelabelAlias } from "@/models/clients";

const props = defineProps<{
  alias: WhitelabelAlias;
  whitelabel: IWhitelabel;
}>();

const emit = defineEmits<{
  "alias:delete": [];
}>();

const offset = COMMON_MENU_OFFSET;

const { t } = useI18n();

const userAlias = computed(() => {
  const userName = [props.alias.user.first_name, props.alias.user.last_name]
    .filter(Boolean)
    .map((item) => item.toLowerCase())
    .join(".");
  return `${userName}@${props.whitelabel.domain_name}`;
});

const menuItems = computed<Array<MenuItem>>(() => [
  {
    label: t("COMMON.DELETE"),
    handler: () => emit("alias:delete"),
  },
]);
</script>
